// extracted by mini-css-extract-plugin
export var fadeInOut = "_32-3";
export var icon = "_32-4";
export var savedIndicator = "_32-2";
export var savingIndicator = "_32-0";
export var spin = "_32-1";